var map = {
	"./biao_xing_records.api.js": "5a25",
	"./breed.items.api.js": "b16e",
	"./dashboard.api.js": "0834",
	"./events.api.js": "904d",
	"./farm_daily_production_records.api.js": "d6ed",
	"./farms.api.js": "b41a",
	"./item_select_records.api.js": "f1e5",
	"./item_tags.api.js": "a4f4",
	"./permissions.api.js": "0a5d",
	"./production.records.api.js": "1f82",
	"./role.api.js": "91d3",
	"./subscriptions.api.js": "b1e5",
	"./super_admin.api.js": "d4bd",
	"./tenant.api.js": "8ebf",
	"./tenant.users.api.js": "4a16",
	"./users.api.js": "f941",
	"./yu_zhong_records.api.js": "cb71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ed5";